const aaa = [
	
	{
		path: "charger",
		component: () => import("@/views/huotiguanli/charger.vue"),
		meta:{title:'活体负责人'},
	},{
		path: "royalty",
		component: () => import("@/views/huotiguanli/royalty.vue"),
		meta:{title:'负责人提成'},
	}
]
export default aaa;